import { useCallback, useEffect, useState } from 'react';
import { reaction } from 'mobx';

import { Channel, RhinoEPGProgram, useFetchChannelPrograms } from '@kaltura-ott/tvpil-shared';

import { config } from 'components/pages/Epg/config';
import { epgLocalTimeStampStorage } from 'components/pages/Epg/storages';
import { useRhinoErrorReaction } from 'hooks/common/useRhinoErrorReaction';

import { filterVisiblePrograms } from '../../utils/filterVisiblePrograms/filterVisiblePrograms';

export function useVisiblePrograms(channel: Channel): RhinoEPGProgram[] {
  const [visiblePrograms, setVisiblePrograms] = useState<any>([]);
  const { data: programs, error, refetch } = useFetchChannelPrograms({
    days: epgLocalTimeStampStorage.gridVisibleDays(),
    channelId: channel.id,
    withPlaceholders: {
      startDate: epgLocalTimeStampStorage.getStartDate(),
      endDate: epgLocalTimeStampStorage.getEndDate(),
    },
  });

  const setArray = useCallback(() => {
    const filteredPrograms = filterVisiblePrograms(programs);
    setVisiblePrograms(filteredPrograms);
  }, [programs]);

  useEffect(() => {
    const disposer = reaction(
      () => epgLocalTimeStampStorage.viewTimestamp,
      () => setArray(),
      {
        delay: config.delayForHorisontalFiltering,
      },
    );

    return () => {
      disposer();
    };
  }, [programs]);

  useEffect(() => {
    setArray();
  }, [programs]);

  useRhinoErrorReaction({ error, refetch, isFetchEpgPrograms: true });

  return visiblePrograms;
}
